export const getTextFields = (servicesData: any) => [
    {
        id: "services",
        name: "name",
        label: "Name",
        type: "text",
        placeholder: "Enter Name",
        required: true,
        capitalizedFirst: true,
        value: servicesData?.name
    },
    {
        label: "Status",
        value: servicesData?.enabled === true ? 'Enabled' : 'Disabled',
        formField: false,
    },
    {
        name: "description",
        label: "Description",
        type: "text",
        placeholder: "Enter Description",
        required: false,
        value: servicesData?.description
    },
   
  
];